import React, { useState, useEffect, useCallback } from "react";
import "./Dashboard.css";
import Header from "../header/Header";
import authService from "../../services/auth.service";
import Sidebar from "../Sidebar";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import VivahApi from "../../api";
import StatsCard from "../components/StatsCard";

function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      if (!authService.isAdmin()) navigate('/');
    } catch (e) {
      console.warn('Admin guard failed', e);
    }
  }, [navigate]);

  const [adminName, setAdminName] = useState('Admin');
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const user = authService.getCurrentUser();
      if (user?.name || user?.email) { setAdminName(user.name || user.email); return; }
      const token = authService.getIdToken();
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        setAdminName(payload.name || payload.email || 'Admin');
      }
    } catch (e) { /* ignore */ }
  }, []);

  const loadStats = useCallback(async () => {
    setLoading(true);
    try {
      const resp = await VivahApi.Admin.listUnverifiedUsers();
      const users = resp?.data?.users || [];

      const isM = u => u.gender === 'M' || u.gender?.toLowerCase() === 'male';
      const isF = u => u.gender === 'F' || u.gender?.toLowerCase() === 'female';

      setStats({
        total:       users.length,
        male:        users.filter(isM).length,
        female:      users.filter(isF).length,
        paid:        users.filter(u => u.isPaid === true).length,
        active:      users.filter(u => u.enabled !== false && u.status === 'CONFIRMED').length,
        unapproved:  users.filter(u => u.status !== 'CONFIRMED' && u.enabled !== false).length,
        deactivated: users.filter(u => u.enabled === false).length,
      });
    } catch (e) {
      console.warn('Failed to load admin stats', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadStats(); }, [loadStats]);

  const CARDS = [
    { type: 'total',       title: 'Total Users'  },
    { type: 'male',        title: 'Male'         },
    { type: 'female',      title: 'Female'       },
    { type: 'paid',        title: 'Paid'         },
    { type: 'active',      title: 'Active'       },
    { type: 'unapproved',  title: 'Unapproved'  },
    { type: 'deactivated', title: 'Deactivated'  },
  ];

  return (
    <div className="gla_page" id="gla_page">
      <a href="#gla_page" className="gla_top ti ti-angle-up gla_go"></a>
      <Header />
      <div className="gla_page_title gla_image_bck gla_wht_txt" data-color="#282828">
        <div className="container text-left">
          <div className="row">
            <div className="col-md-8">
              <h1 className="gla_h1_title">Dashboard</h1>
            </div>
          </div>
        </div>
      </div>

      <section id="gla_content" className="gla_content">
        <section className="gla_section">
          <div className="dashboard">
            <div className="row">
              <Sidebar />
              <div className="col-md-10 col-xs-12 dashboard_container">
                <div className="dash-welcome">
                  Welcome back, <strong>{adminName}</strong>
                </div>

                {loading ? (
                  <div className="dash-loading">Loading stats…</div>
                ) : (
                  <div className="panels">
                    {CARDS.map(({ type, title }) => (
                      <StatsCard key={type} type={type} title={title} value={stats?.[type] ?? 0} />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </section>
      <Footer />
    </div>
  );
}

export default Dashboard;
